import React, { Component } from 'react'
import styled from 'styled-components'
import AdvertSignWrapper from './AdvertSignWrapper'
import SashecAdvert from './SashecAdvert'
import { SIZES } from '../../../constants'

const TopBanner = styled.div`
  display: block;
  height: auto;
  max-height: 210px;
  overflow: hidden;
  position: relative;
  text-align: center;
 
  @media screen and (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    margin: 15px auto;
    width: 100%;
  }
  
  @media screen and (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    margin-bottom: 10px;
  }
`

const BannerWrapper = styled.div`
  display: block;
  margin: 0 auto;
  max-width: 1080px;
  position: relative;
  text-align: center;
  width: auto;
  
  @media screen and (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    max-width: 100%;
  }
`

export default class LeaderBoard extends Component {
  shouldComponentUpdate () {
    return false
  }

  render () {
    const {
      widget: {
        meta: {
          targetId,
          size
        }
      }
    } = this.props

    return (
      <TopBanner>
        <BannerWrapper>
          <div id={`${targetId}-wrapper`}>
            <AdvertSignWrapper/>
            <SashecAdvert id={targetId} size={size}/>
          </div>
        </BannerWrapper>
      </TopBanner>
    )
  }
}
